import React from 'react';
import PropTypes from 'prop-types';
import './Line.css';
import { countSyllables } from '../utils/text';

export default class Line extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.expanded || false,
      editId: null,
      pos: null,
    };

    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.handleEditAltLine = this.handleEditAltLine.bind(this);
    this.handleSelectItem = this.handleSelectItem.bind(this);
    this.setCharPos = this.setCharPos.bind(this);
  }

  setCharPos(pos) {
    this.setState(Object.assign({}, this.state, {
      pos,
    }));
  }

  handleEditAltLine(event, lineId, pos) {
    // event.preventDefault();
    event.stopPropagation();
    this.setState(Object.assign({}, this.state, {
      editId: lineId,
      pos: pos || null,
    }));
  }

  handleSelectItem(event) {
    event.preventDefault();
    document.getSelection().removeAllRanges();
    if (this.props.onToggleSelect && (event.metaKey || event.shiftKey || event.altKey)) {
      this.props.onToggleSelect();
    } else if (this.props.onSelect) {
      this.props.onSelect();
    }
  }

  toggleExpanded() {
    this.setState(Object.assign({}, this.state, {
      expanded: !this.state.expanded,
    }));
  }

  focus(input) {
    if (input) {
      input.focus();
      input.setSelectionRange(this.state.pos, this.state.pos);
    }
  }

  render() {
    const { props } = this;

    if (props.line) {
      return (
        <div className="line d-flex w-100 justify-content-between">
          <div className="line-toggle">
            {props.uiToggles.ids && <span className="id id-left text-muted">{props.line.id}</span>}
            {props.line.text || (
              <small className="text-muted" style={{ fontStyle: 'italic' }}>
                Blank Line
              </small>
            )}
            {/* <button type="button" className="btn btn-link btn-sm">▼</button> */}
          </div>

          {(props.uiToggles.stresses || props.uiToggles.syllables) && (
            <span>
              {props.uiToggles.syllables && (
                <span
                  className={`line-syllables text-center${
                    props.line.syllables ? '' : ' text-muted'
                  }`}
                >
                  {props.line.syllables
                    ? props.line.syllables
                    : `? ${countSyllables(props.line.text)}`}
                  {/* <small title="Number of Syllables"> sybl.</small> */}
                </span>
              )}
              {props.uiToggles.stresses && props.uiToggles.syllables && ' / '}
              {props.uiToggles.stresses && (
                <span>
                  {props.line.stresses || <span className="text-muted">?</span>}{' '}
                  {/* <small title="Number of Stresses">strs.</small> */}
                </span>
              )}
            </span>
          )}
        </div>
      );
    }
    return <div className="line line-empty" />;
  }
}

Line.propTypes = {
  line: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    syllables: PropTypes.number,
    stresses: PropTypes.number,
  }).isRequired,
  onSelect: PropTypes.func,
  onToggleSelect: PropTypes.func,
  uiToggles: PropTypes.objectOf(PropTypes.bool),
};
Line.defaultProps = {
  uiToggles: {},
  onSelect: undefined,
  onToggleSelect: undefined,
};



// WEBPACK FOOTER //
// ./src/components/Line.js